import { useTranslation } from 'gatsby-plugin-react-i18next'
import { isEmail } from '../utils/validation'

export type ContactFormFields = {
  contact_name: string
  contact_email: string
  contact_comments: string
  contact_genre: (typeof contanctGenre)[number] | null
}
const contanctGenre = [
  'General inquiries',
  'Getting started',
  'Billing',
  'Order status',
  'My critique',
  'Unsubscribing and opting out',
  'Resume support',
] as const

type ContactFormFieldKeys = keyof ContactFormFields

const useContactFormValidation = (): ((
  obj: ContactFormFields
) => Record<ContactFormFieldKeys, string | null>) => {
  const { t } = useTranslation()
  const tRef = 'contactForm.validationMessages'

  const validateSchema = (
    obj: ContactFormFields
  ): Record<ContactFormFieldKeys, string | null> => {
    const validatedObject = {} as Record<ContactFormFieldKeys, string | null>

    for (const key in obj) {
      if (obj.hasOwnProperty(key)) {
        const fieldInput = (obj[key as ContactFormFieldKeys] ?? '').trim()

        // Validation rules based on field key
        switch (key) {
          case 'contact_name':
            validatedObject[key] = fieldInput.length
              ? null
              : t(`${tRef}.nameValidation`)

            break
          case 'contact_email':
            validatedObject[key] = fieldInput.length
              ? !isEmail(fieldInput)
                ? t(`${tRef}.invalidEmail`)
                : null
              : t(`${tRef}.emailValidation`)
            break
          case 'contact_comments':
            validatedObject[key] = fieldInput.length
              ? null
              : t(`${tRef}.commentValidation`)
            break
          case 'contact_genre':
            validatedObject[key] = fieldInput.length
              ? null
              : t(`${tRef}.genreValidation`)
            break
          default:
            break
        }
      }
    }

    return validatedObject
  }

  return validateSchema
}

export { contanctGenre, useContactFormValidation }
